import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthorizePPService } from '../authorizePP/authorizePP.service';
import { AppInjector } from '../authorizePP/app-injector';
declare var jquery: any;
declare var $: any;
@Component({
    selector: 'public',
    templateUrl: './public.component.html'
})
export class PublicComponent {
    constructor() {

    }
    private authorize = AppInjector.get(AuthorizePPService);
    public token: string = "access_token";
    public NotImage: string = "assets/more/img/avatar/notfound.png";
    public getToken(): (string | null) {
        let token = window.localStorage.getItem(this.token);
        return token;
    }

    public setToken(val: string): void {
        window.localStorage.setItem(this.token, val);
    }

    public NewId() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    public getBaseUrl() {
        // var url = 'http://localhost:91/';
        // //var url = 'http://localhost:60764/vnn_appWF/';
        // //var url = '/';
        // return url;
        return document.getElementsByTagName('basevnn')[0].getAttribute('href');
    }

    loadCSS(url_array, tagname, callback) {
        var this_sav = this;
        var numCSSs = url_array.length;
        var count = 0;
        let tagAng = document.getElementsByTagName(tagname)[0];
        let css_private = tagAng.getElementsByTagName('head')[0];
        console.log(css_private);
        var cssExists = function(url) {
            return document.querySelectorAll(`link[href="${url}"]`).length > 0;
        }

        var onLoadCSS = function() {
            count += 1;
        
            if (count === numCSSs) {
                callback(1,'ok');
            } else {
                if(!cssExists(url_array[count])) {
                    addCSS();
                }
                else {
                    onLoadCSS(); 
                }
            }
        }
        
        function addCSS() {
            let css = document.createElement('link');
            css.href = url_array[count];
            css.rel = "stylesheet";
            css.type = "text/css";
            css.onload = onLoadCSS;
            css_private.appendChild(css);
        }
        addCSS();
    }

    loadScript(url_array, tagname, callback) {
        var this_sav = this;
        var numScripts = url_array.length;
        var count = 0;
        let tagAng = document.getElementsByTagName(tagname)[0];

        var scriptExists = function(url) {
            let elements = document.querySelectorAll(`script[src="${url}"]`);
            Array.prototype.forEach.call( elements, function( node ) {
                node.parentNode.removeChild( node );
            });
        }

        var onLoadScript = function() {
            count += 1;
        
            if (count === numScripts) {
                callback(1,'ok');
            } else {
                scriptExists(url_array[count]);
                addScript();
                // if(!scriptExists(url_array[count])) {
                //     addScript();
                // }
                // else {
                //     onLoadScript();
                // }
            }
        }
        
        function addScript() {
            var script = document.createElement('script');
            script.src = url_array[count];
            script.onload = onLoadScript;
            tagAng.appendChild(script);
        }
        
        addScript();
    }

    public callAPI(url: string, method: string, data: any, header: any, callback: Function) {
        var this_sav = this;
        var token = this.getToken();
        var url_ = this.getBaseUrl() + url;
        var data_js = JSON.stringify(data);
        if(data_js != "{}") {
            return (
                $.ajax(url_, {
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('Authorization', token);
                    },
                    method: method,
                    data: data_js,
                    contentType: "application/json",
                    dataType: "json",
                    success: function (result) {
                        callback(result.status, result.mess);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if(jqXHR != null) {
                            if(jqXHR.responseText != null) {
                                if(jqXHR.responseText.startsWith('Unauthorized')) {
                                    this_sav.authorize.UnAuthorize();
                                }
                            }
                        }
                        callback(0, textStatus);
                    }
                })
            )
        }
        else {
            data_js = data;
            return (
                $.ajax(url_, {
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('Authorization', token);
                    },
                    method: method,
                    data: data_js,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (result) {
                        callback(result.status, result.mess);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if(jqXHR != null) {
                            if(jqXHR.responseText != null) {
                                if(jqXHR.responseText.startsWith('Unauthorized')) {
                                    this_sav.authorize.UnAuthorize();
                                }
                            }
                        }
                        callback(0, textStatus);
                    }
                })
            )
        }
    };

    public convertToSlug(slug)
    {
        //Đổi chữ hoa thành chữ thường
        slug = slug.toLowerCase();
    
        //Đổi ký tự có dấu thành không dấu
        slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
        slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
        slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
        slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
        slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
        slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
        slug = slug.replace(/đ/gi, 'd');
        //Xóa các ký tự đặt biệt
        slug = slug.replace(/\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi, '');
        //Đổi khoảng trắng thành ký tự gạch ngang
        slug = slug.replace(/ /gi, "-");
        //Đổi nhiều ký tự gạch ngang liên tiếp thành 1 ký tự gạch ngang
        //Phòng trường hợp người nhập vào quá nhiều ký tự trắng
        slug = slug.replace(/\-\-\-\-\-/gi, '-');
        slug = slug.replace(/\-\-\-\-/gi, '-');
        slug = slug.replace(/\-\-\-/gi, '-');
        slug = slug.replace(/\-\-/gi, '-');
        //Xóa các ký tự gạch ngang ở đầu và cuối
        slug = '@' + slug + '@';
        slug = slug.replace(/\@\-|\-\@|\@/gi, '');
        return slug;
    }

    //#region Select2 get set update Value
    updateSelect2Value(arr, select) {
        var Uloption = select.next().find('ul.select2-selection__rendered');
        for(var i = arr.length - 1; i >= 0; i--) {
            Uloption.children("li.select2-selection__choice").each(function(){
                if($(this).attr('idvnn') == arr[i]) {
                    $(this).detach();
                    Uloption.prepend($(this));
                    return false;
                }
            });
        }
    }

    getValSelect2(select) {
        var Uloption = select.next().find('ul.select2-selection__rendered');
        var val = '';
        Uloption.children("li.select2-selection__choice").each(function(){
            val += $(this).attr('idvnn') + ',';
        });

        if(val != '') { val = val.substring(0, val.length - 1); }
        return val;
    }

    setValSelect2(select, val) {
        var this_sav = this;
        var strarr = this_sav.getValSelect2(select);
        setTimeout(() => {
            var arr = strarr.split(',');
            var index = arr.indexOf(val);
            if (index !== -1) {
                arr.splice(index, 1);
            }
            else {
                arr.push(val);
            }
            this_sav.updateSelect2Value(arr, select);
        }, 0);
    }
    //#endregion Select2 get set update Value
}



// WEBPACK FOOTER //
// ./src/app/public/public.component.ts